export default __webpack_public_path__ + "static/media/JobPosition_Background.eb81823a.svg";